import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import { Layout, LayoutType } from '../components/layout'
import SEO from '../components/seo'
import styles from './index.module.css'
import QueryParams from '../components/query-params'

const NewsIndex = (props) => {
  const posts = props.data.allMarkdownRemark.edges
  const news = posts.filter(({ node }) => node.frontmatter.category === 'News').slice(0, 15) // only show last x items
  const shortTitle = props.data.site.siteMetadata.shortTitle
  
  return (
    <>
      <QueryParams />
      <Layout location={props.location} type={LayoutType.News}>
        <SEO 
          location={props.location}
          title={shortTitle} 
        />
        {news.length > 0 && <p className={styles.articlesHeading}>Latest News</p>}
        <div className={styles.articlesContainerBlog}>
          {news.map(({ node }) => {
            const title = node.frontmatter.title || node.fields.slug
            return (
              <article 
                key={node.fields.slug} 
                className={styles.card}
              >
                <Link to={node.fields.slug}>
                  <img alt={node.frontmatter.title} className={styles.cardImage} src={node.frontmatter.thumbnail.childImageSharp.sizes.src} />
                </Link>
                <hr className={styles.cardDivider}/>
                <div className={styles.cardBody}>
                  <header>
                    <p className={styles.cardHeading}>
                      <Link to={node.fields.slug}>
                        {title}
                      </Link>
                    </p>
                    <small>{node.frontmatter.date}</small>
                  </header>
                  <section>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: node.frontmatter.description || node.excerpt,
                      }}
                    />
                  </section>
                </div>
              </article>
            )
          })}
        </div>
      </Layout>
    </>
  )
}

NewsIndex.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

export default NewsIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        shortTitle
      }
    }
    allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}, filter: {fields: {slug: {ne: "/terms/"}}}) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            category
            thumbnail {
              childImageSharp {
                sizes(maxWidth: 300) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`
